import React from 'react'
import {NavLink} from 'react-router-dom'
import MapIcon from '../components/icons/MapIcon'
import LocationIcon from '../components/icons/LocationIcon'
import BellIcon from '../components/icons/BellIcon'
import ProfileIcon from '../components/icons/ProfileIcon'

const MobileNav = () => {
    return(
        <nav className='fixed bottom-0 left-0 h-[60px] border-t border-custom-charcoal w-full bg-custom-dark z-[1000]'>
            <ul className='w-full h-full px-5 flex justify-center text-xs text-center gap-6'>
                <li className='w-full sm:w-[80px]'>
                    <NavLink 
                        to="/" 
                        className={({isActive}) => `flex flex-col gap-1 h-full justify-end pb-2 items-center  ${isActive ? 'active' : ''}`}
                    >
                        <div>
                            <MapIcon />
                        </div>
                        <div>Map</div>
                    </NavLink>
                </li>

                <li className='w-full sm:w-[80px]'>
                    <NavLink 
                        to="/saved-spots" 
                        className={({isActive}) => `flex flex-col gap-1 h-full justify-end pb-2 items-center  ${isActive ? 'active' : ''}`}
                    >
                        <div>
                            <LocationIcon />
                        </div>
                        <div>My Spots</div>
                    </NavLink>
                </li>

                <li className='w-full sm:w-[80px]'>
                    <NavLink 
                        to="/account/overview" 
                        className={({isActive}) => `flex flex-col gap-1 h-full justify-end pb-2 items-center  ${isActive ? 'active' : ''}`}
                    >
                        <div>
                            <ProfileIcon />
                        </div>
                        <div>Account</div>
                    </NavLink>
                </li>

                <li className='w-full sm:w-[80px]'>
                    <NavLink 
                        to="/alerts" 
                        className={({isActive}) => `flex flex-col gap-1 h-full justify-end pb-2 items-center  ${isActive ? 'active' : ''}`}
                    >
                        <div>
                            <BellIcon />
                        </div>
                        <div>Alerts</div>
                    </NavLink>
                </li> 
            </ul>
        </nav>
    )
}

export default MobileNav